import { ConfigProvider } from 'antd';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import enUS from 'antd/lib/locale/en_US';
import zhCN from 'antd/lib/locale/zh_CN';

export interface WrapperProTableProps {
  children: ReactNode;
}

const WrapperLocaleProvider = ({ children }: WrapperProTableProps) => {
  const { i18n } = useTranslation();
  return (
    <ConfigProvider locale={i18n.language === 'zh-CN' ? zhCN : enUS}>
      {children}
    </ConfigProvider>
  );
};

export default WrapperLocaleProvider;
